import { render, staticRenderFns } from "./crudZones.vue?vue&type=template&id=fa61ee80&scoped=true"
import script from "./crudZones.vue?vue&type=script&lang=js"
export * from "./crudZones.vue?vue&type=script&lang=js"
import style0 from "./crudZones.vue?vue&type=style&index=0&id=fa61ee80&prod&lang=css"
import style1 from "./crudZones.vue?vue&type=style&index=1&id=fa61ee80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61ee80",
  null
  
)

export default component.exports